/* Swan Canada — Shop by Room
   No external libraries. Designed for large galleries with batched rendering and on-demand product requests. */
(function () {
  'use strict';

  if (window.__SWAN_SHOP_BY_ROOM_SCRIPT__) return;
  window.__SWAN_SHOP_BY_ROOM_SCRIPT__ = true;

  const ROOM_ORDER = [
    'All',
    'Living Room',
    'Bedroom',
    'Dining Room',
    'Office',
    'TV Wall',
    'Bathroom',
    'Outdoor',
    'Entrance',
    'Retail Store',
    'Restaurant'
  ];

  const CATEGORY_ORDER = [
    'WPC Fluted Panels',
    'UV Marble Sheets',
    '3D Wall Panels',
    'Wallpaper',
    '3D Wallpaper',
    'Wall Arts',
    'Water Vapor Fireplace',
    'Chipboard',
    'Faux Stone',
    'PU Leather Panels',
    'PS Fluted Panels',
    'Outdoor Fluted Panels',
    'Acoustic Wall Panels',
    'Flex Stone',
    'PVC Wallpaper Sticker'
  ];

  const CATEGORY_COLLECTIONS = {
    'WPC Fluted Panels': 'fluted-panels',
    'UV Marble Sheets': 'uv-marble-sheet',
    '3D Wall Panels': '3d-wall-panels',
    'Wallpaper': 'wallpaper',
    '3D Wallpaper': '3d-wallpaper',
    'Wall Arts': 'wall-arts',
    'Water Vapor Fireplace': 'fireplace',
    'Chipboard': 'chip-board',
    'Faux Stone': 'faux-stone',
    'PU Leather Panels': 'pu-leather-panels',
    'PS Fluted Panels': 'ps-fluted-panels',
    'Outdoor Fluted Panels': 'outdoor-fluted',
    'Acoustic Wall Panels': 'acoustic',
    'Flex Stone': 'flex-stone',
    'PVC Wallpaper Sticker': 'pvc-wallpaper'
  };

  const CATEGORY_SEARCH_ALIASES = {
    'WPC Fluted Panels': ['wpc', 'wood plastic composite', 'fluted panel', 'slat wall', 'fluted-panels'],
    'UV Marble Sheets': ['uv marble', 'marble sheet', 'marble panel', 'uv-marble-sheet'],
    '3D Wall Panels': ['3d wall panel', 'pvc 3d panel', '3d-wall-panels'],
    'Wallpaper': ['wallpaper'],
    '3D Wallpaper': ['3d wallpaper', '3d-wallpaper'],
    'Wall Arts': ['wall art', 'wall-arts'],
    'Water Vapor Fireplace': ['water vapor fireplace', 'water vapour fireplace', 'fireplace'],
    'Chipboard': ['chipboard', 'chip board'],
    'Faux Stone': ['faux stone', 'pu stone', 'stone panel'],
    'PU Leather Panels': ['pu leather', 'leather panel'],
    'PS Fluted Panels': ['ps fluted', 'polystyrene fluted'],
    'Outdoor Fluted Panels': ['outdoor fluted', 'exterior slat', 'outdoor panel'],
    'Acoustic Wall Panels': ['acoustic panel', 'sound panel', 'acoustic'],
    'Flex Stone': ['flex stone', 'flexible stone'],
    'PVC Wallpaper Sticker': ['pvc wallpaper', 'wallpaper sticker', 'pvc sticker']
  };

  const selectors = {
    section: '[data-sbr-section]',
    account: '[data-sbr-account-favourites]'
  };

  const escapeHTML = (value) => String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

  const asArray = (value) => {
    if (Array.isArray(value)) return value.map((item) => String(item).trim()).filter(Boolean);
    if (typeof value === 'string') return value.split(',').map((item) => item.trim()).filter(Boolean);
    return [];
  };

  const unique = (values) => Array.from(new Set(values.filter(Boolean)));

  const debounce = (fn, delay) => {
    let timer;
    return function debounced() {
      const args = arguments;
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  };

  const ensureRoot = (value) => {
    const root = String(value || '/');
    return root.endsWith('/') ? root : `${root}/`;
  };

  const toAbsoluteUrl = (url) => {
    if (!url) return '';
    if (url.startsWith('//')) return `https:${url}`;
    return url;
  };

  const createRootURL = (rootUrl) => {
    try {
      return new URL(rootUrl);
    } catch (error) {
      return new URL(rootUrl, window.location.origin);
    }
  };

  const responsiveImageUrl = (url, width) => {
    const absolute = toAbsoluteUrl(url);
    if (!absolute || !width) return absolute;

    try {
      const parsed = new URL(absolute, window.location.origin);
      if (/cdn\.shopify\.com$|\.myshopify\.com$|swancanada\.ca$/i.test(parsed.hostname)) {
        parsed.searchParams.set('width', String(width));
        return parsed.toString();
      }
    } catch (error) {
      return absolute;
    }

    return absolute;
  };

  const parsePriceToCents = (value) => {
    if (typeof value === 'number' && Number.isFinite(value)) return Math.round(value);
    const text = String(value == null ? '' : value).trim().replace(/[^0-9.-]/g, '');
    if (!text) return 0;
    if (text.includes('.')) return Math.round(Number.parseFloat(text) * 100);
    const number = Number.parseInt(text, 10);
    return Number.isFinite(number) ? number : 0;
  };

  const normaliseHandle = (value) => {
    const input = String(value || '').trim();
    if (!input) return '';
    const match = input.match(/\/products\/([^/?#]+)/i);
    return (match ? match[1] : input).replace(/^\/+|\/+$/g, '');
  };

  const numericPhotoPart = (value) => {
    const match = String(value || '').match(/(\d+)/);
    return match ? Number.parseInt(match[1], 10) : Number.MAX_SAFE_INTEGER;
  };


  const normaliseSearchValue = (value) => {
    let text = String(value == null ? '' : value);
    try {
      text = decodeURIComponent(text);
    } catch (error) {
      // Keep the original value when it is not URL encoded.
    }
    try {
      text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    } catch (error) {
      // String.normalize is supported by modern storefront browsers; this is a safe fallback.
    }
    return text
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/\bcolour\b/g, 'color')
      .replace(/\bcolours\b/g, 'colors')
      .replace(/\bgrey\b/g, 'gray')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .replace(/\s+/g, ' ');
  };

  const compactSearchValue = (value) => normaliseSearchValue(value).replace(/[^a-z0-9]/g, '');

  const extractSkuAliases = (value) => {
    let text = String(value == null ? '' : value);
    try {
      text = decodeURIComponent(text);
    } catch (error) {
      // Keep the original value when it is not URL encoded.
    }
    text = text.toUpperCase();
    const found = [];
    const matcher = /(?:^|[^A-Z0-9])((?:SW|SM)[A-Z0-9]{3,})(?=$|[^A-Z0-9])/g;
    let match;
    while ((match = matcher.exec(text)) !== null) {
      const sku = match[1];
      found.push(sku);
      if (sku.startsWith('SW')) found.push(`SM${sku.slice(2)}`);
      if (sku.startsWith('SM')) found.push(`SW${sku.slice(2)}`);
    }
    return unique(found);
  };

  const inferCategoriesFromText = (value) => {
    const text = normaliseSearchValue(value);
    if (!text) return [];
    return Object.entries(CATEGORY_SEARCH_ALIASES)
      .filter(([, aliases]) => aliases.some((alias) => text.includes(normaliseSearchValue(alias))))
      .map(([category]) => category);
  };

  const getFocusableElements = (container) => Array.from(container.querySelectorAll(
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
  )).filter((element) => !element.hasAttribute('hidden') && element.offsetParent !== null);

  class SwanShopByRoom {
    constructor(root) {
      this.root = root;
      this.dataUrl = root.dataset.dataUrl;
      this.rootUrl = ensureRoot(root.dataset.rootUrl);
      this.loginUrl = root.dataset.loginUrl || `${this.rootUrl}account/login`;
      this.customerId = root.dataset.customerId || '';
      this.currency = root.dataset.currency || 'CAD';
      this.initialCount = Number.parseInt(root.dataset.initialCount || '12', 10);
      this.batchCount = Number.parseInt(root.dataset.batchCount || '12', 10);
      this.autoLoadMore = root.dataset.autoLoadMore === 'true';
      this.maxProducts = Number.parseInt(root.dataset.maxProducts || '4', 10);
      this.defaultSort = root.dataset.defaultSort || 'featured';
      this.anchor = root.dataset.sectionAnchor || 'shop-by-room';

      this.photos = [];
      this.filteredPhotos = [];
      this.selectedRoom = 'All';
      this.selectedCategories = new Set();
      this.searchTerm = '';
      this.searchDisplayTerm = '';
      this.searchTokens = [];
      this.searchCompact = '';
      this.remoteSearchHandles = new Set();
      this.remoteSearchCategories = new Set();
      this.searchRequestToken = 0;
      this.searchAbortController = null;
      this.sortMode = this.defaultSort;
      this.visibleCount = this.initialCount;
      this.currentPhoto = null;
      this.currentModalList = [];
      this.currentModalIndex = -1;
      this.currentProducts = [];
      this.productCache = new Map();
      this.collectionCache = new Map();
      this.productRequestToken = 0;
      this.lastFocusedElement = null;
      this.toastTimer = null;

      this.gallery = root.querySelector('[data-sbr-gallery]');
      this.results = root.querySelector('[data-sbr-results]');
      this.mobileResults = root.querySelector('[data-sbr-mobile-results]');
      this.categoriesContainer = root.querySelector('[data-sbr-categories]');
      this.activeFilters = root.querySelector('[data-sbr-active-filters]');
      this.emptyState = root.querySelector('[data-sbr-empty]');
      this.loadArea = root.querySelector('[data-sbr-load-area]');
      this.loadMoreButton = root.querySelector('[data-sbr-load-more]');
      this.progress = root.querySelector('[data-sbr-progress]');
      this.searchInput = root.querySelector('[data-sbr-search]');
      this.sortSelect = root.querySelector('[data-sbr-sort]');
      this.filterPanel = root.querySelector('[data-sbr-filter-panel]');
      this.filterBackdrop = root.querySelector('[data-sbr-filter-backdrop]');
      this.filterTotal = root.querySelector('[data-sbr-filter-total]');
      this.mobileFilterButton = root.querySelector('[data-sbr-open-filters]');
      this.stickyControls = root.querySelector('[data-sbr-sticky-controls]');
      this.stickySentinel = root.querySelector('[data-sbr-sticky-sentinel]');
      this.stickyFrame = null;
      this.stickyResizeObserver = null;
      this.autoLoadObserver = null;
      this.autoLoadPending = false;
      this.isAppendingPhotos = false;

      this.modal = root.querySelector('[data-sbr-modal]');
      this.dialog = root.querySelector('[data-sbr-dialog]');
      this.modalImage = root.querySelector('[data-sbr-modal-image]');
      this.imageLoader = root.querySelector('[data-sbr-image-loader]');
      this.modalNumber = root.querySelector('[data-sbr-modal-number]');
      this.modalTitle = root.querySelector('[data-sbr-modal-title]');
      this.modalCaption = root.querySelector('[data-sbr-modal-caption]');
      this.modalTags = root.querySelector('[data-sbr-modal-tags]');
      this.modalFavourite = root.querySelector('[data-sbr-modal-favourite]');
      this.productsStatus = root.querySelector('[data-sbr-products-status]');
      this.productsContainer = root.querySelector('[data-sbr-products]');
      this.addAllButton = root.querySelector('[data-sbr-add-all]');
      this.authDialog = root.querySelector('[data-sbr-auth-dialog]');
      this.authSignInLink = this.authDialog ? this.authDialog.querySelector('.sbr-auth-primary') : null;
      this.toast = root.querySelector('[data-sbr-toast]');

      this.onKeyDown = this.onKeyDown.bind(this);
      this.onViewportChange = this.scheduleStickyMetrics.bind(this);
    }

    async init() {
      if (this.root.dataset.sbrInitialized === 'true') return;
      this.root.dataset.sbrInitialized = 'true';
      this.bindEvents();
      this.initStickyControls();

      if (this.sortSelect) this.sortSelect.value = this.sortMode;

      try {
        const response = await fetch(this.dataUrl, { credentials: 'same-origin' });
        if (!response.ok) throw new Error(`Gallery data returned ${response.status}`);
        const payload = await response.json();
        if (!Array.isArray(payload)) throw new Error('Gallery data must be a JSON array.');

        this.photos = payload
          .map((photo, index) => this.normalisePhoto(photo, index))
          .filter((photo) => photo.imageUrl && photo.photoNumber);

        this.renderCategoryFilters();
        this.updateRoomCounts();
        this.applyDeepLinkedFilters();
        this.applyFilters({ closeDrawer: false });
        this.initAutoLoadMore();
        this.openDeepLinkedPhoto();
      } catch (error) {
        console.error('[Swan Shop by Room]', error);
        this.showDataError();
      }
    }

    normalisePhoto(photo, index) {
      const photoNumber = String(photo.photo_number || photo.photoNumber || `SBR-${String(index + 1).padStart(4, '0')}`).trim();
      const rooms = unique(asArray(photo.rooms).filter((room) => ROOM_ORDER.includes(room) && room !== 'All'));
      const categories = unique(asArray(photo.categories));
      const products = unique(asArray(photo.products).map(normaliseHandle));
      const explicitSkus = unique([
        ...asArray(photo.skus || photo.sku),
        ...extractSkuAliases(`${photo.photo_number || ''} ${photo.title || ''} ${photo.alt || ''} ${photo.image_url || photo.imageUrl || ''} ${products.join(' ')}`)
      ]);
      const colors = unique(asArray(photo.colors || photo.colours || photo.color || photo.colour));
      const keywords = unique(asArray(photo.keywords || photo.search_terms || photo.searchTerms));
      const width = Math.max(1, Number.parseInt(photo.width || '1600', 10));
      const height = Math.max(1, Number.parseInt(photo.height || '1200', 10));
      const primaryRoom = rooms[0] || 'Living Room';
      const primaryCategory = categories[0] || 'Swan Wall Décor';
      const alt = String(photo.alt || `${primaryRoom} inspiration featuring ${primaryCategory}`).trim();
      const title = String(photo.title || `${primaryRoom} Inspiration`).trim();
      const dateValue = String(photo.date || '2000-01-01');
      const timestamp = Number.isNaN(Date.parse(dateValue)) ? 0 : Date.parse(dateValue);
      const imageUrl = toAbsoluteUrl(photo.image_url || photo.imageUrl || '');
      const searchSource = [
        photoNumber,
        alt,
        title,
        rooms.join(' '),
        categories.join(' '),
        products.join(' '),
        explicitSkus.join(' '),
        colors.join(' '),
        keywords.join(' '),
        imageUrl
      ].join(' ');

      return {
        photoNumber,
        imageUrl,
        alt,
        title,
        rooms: rooms.length ? rooms : ['Living Room'],
        categories,
        products,
        skus: explicitSkus,
        colors,
        keywords,
        date: dateValue,
        timestamp,
        width,
        height,
        featured: Boolean(photo.featured),
        originalIndex: index,
        searchText: normaliseSearchValue(searchSource),
        searchCompact: compactSearchValue(searchSource)
      };
    }

    bindEvents() {
      this.root.querySelectorAll('[data-sbr-room]').forEach((button) => {
        button.addEventListener('click', () => this.selectRoom(button.dataset.sbrRoom || 'All'));
      });

      this.categoriesContainer?.addEventListener('change', (event) => {
        const input = event.target.closest('input[data-sbr-category]');
        if (!input) return;
        if (input.checked) this.selectedCategories.add(input.value);
        else this.selectedCategories.delete(input.value);
        this.applyFilters();
      });

      this.searchInput?.addEventListener('input', debounce(() => {
        const rawTerm = this.searchInput.value.trim();
        this.setSearchTerm(rawTerm);
      }, 260));

      this.sortSelect?.addEventListener('change', () => {
        this.sortMode = this.sortSelect.value;
        this.applyFilters();
      });

      this.root.querySelectorAll('[data-sbr-reset]').forEach((button) => {
        button.addEventListener('click', () => this.resetFilters());
      });

      this.root.querySelector('[data-sbr-clear-categories]')?.addEventListener('click', () => {
        this.selectedCategories.clear();
        this.categoriesContainer?.querySelectorAll('input[data-sbr-category]').forEach((input) => {
          input.checked = false;
        });
        this.applyFilters();
      });

      this.loadMoreButton?.addEventListener('click', () => this.loadMore());

      this.gallery?.addEventListener('click', (event) => {
        const favouriteButton = event.target.closest('[data-sbr-favourite]');
        if (favouriteButton) {
          event.preventDefault();
          event.stopPropagation();
          this.toggleFavourite(favouriteButton.dataset.photoId);
          return;
        }

        const openButton = event.target.closest('[data-sbr-open-photo]');
        if (openButton) {
          event.preventDefault();
          this.openPhoto(openButton.dataset.photoId);
        }
      });

      this.activeFilters?.addEventListener('click', (event) => {
        const chip = event.target.closest('[data-sbr-remove-filter]');
        if (!chip) return;
        const type = chip.dataset.filterType;
        const value = chip.dataset.filterValue;
        if (type === 'room') this.selectRoom('All');
        if (type === 'category') {
          this.selectedCategories.delete(value);
          const input = this.categoriesContainer?.querySelector(`input[data-sbr-category][value="${CSS.escape(value)}"]`);
          if (input) input.checked = false;
          this.applyFilters();
        }
        if (type === 'search') {
          this.clearSearchState();
          if (this.searchInput) this.searchInput.value = '';
          this.applyFilters({ closeDrawer: false });
        }
      });

      this.root.querySelectorAll('[data-sbr-close-modal]').forEach((element) => {
        element.addEventListener('click', () => this.closeModal());
      });
      this.root.querySelector('[data-sbr-prev]')?.addEventListener('click', () => this.navigateModal(-1));
      this.root.querySelector('[data-sbr-next]')?.addEventListener('click', () => this.navigateModal(1));
      this.root.querySelector('[data-sbr-share]')?.addEventListener('click', () => this.shareCurrentPhoto());
      this.modalFavourite?.addEventListener('click', () => {
        if (this.currentPhoto) this.toggleFavourite(this.currentPhoto.photoNumber);
      });

      this.modalImage?.addEventListener('load', () => {
        this.modalImage.classList.add('is-loaded');
        if (this.imageLoader) this.imageLoader.hidden = true;
      });

      this.modalImage?.addEventListener('error', () => {
        if (this.imageLoader) this.imageLoader.hidden = true;
        if (this.modal && !this.modal.hidden && this.currentPhoto) {
          this.showToast('This photo could not be loaded.');
        }
      });

      this.productsContainer?.addEventListener('change', (event) => {
        const select = event.target.closest('[data-sbr-variant-select]');
        if (!select) return;
        this.updateProductVariant(select);
      });

      this.productsContainer?.addEventListener('click', (event) => {
        const addButton = event.target.closest('[data-sbr-add-product]');
        if (!addButton) return;
        this.addSingleProduct(addButton);
      });

      this.addAllButton?.addEventListener('click', () => this.addAllProducts());

      this.mobileFilterButton?.addEventListener('click', () => this.openFilters());
      this.root.querySelectorAll('[data-sbr-close-filters]').forEach((button) => button.addEventListener('click', () => this.closeFilters()));
      this.filterBackdrop?.addEventListener('click', () => this.closeFilters());

      this.root.querySelectorAll('[data-sbr-close-auth]').forEach((element) => {
        element.addEventListener('click', () => this.hideAuthPrompt());
      });

      this.dialog?.addEventListener('click', (event) => event.stopPropagation());
    }

    selectRoom(room) {
      this.selectedRoom = ROOM_ORDER.includes(room) ? room : 'All';
      this.root.querySelectorAll('[data-sbr-room]').forEach((button) => {
        const active = button.dataset.sbrRoom === this.selectedRoom;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.applyFilters();
    }

    setSearchTerm(rawTerm) {
      this.searchDisplayTerm = String(rawTerm || '').trim();
      this.searchTerm = normaliseSearchValue(this.searchDisplayTerm);
      this.searchTokens = this.searchTerm ? this.searchTerm.split(' ').filter(Boolean) : [];
      this.searchCompact = compactSearchValue(this.searchDisplayTerm);
      this.remoteSearchHandles.clear();
      this.remoteSearchCategories.clear();
      this.applyFilters({ closeDrawer: false });
      this.lookupMatchingProducts(this.searchDisplayTerm);
    }

    clearSearchState() {
      this.searchRequestToken += 1;
      if (this.searchAbortController) this.searchAbortController.abort();
      this.searchAbortController = null;
      this.searchTerm = '';
      this.searchDisplayTerm = '';
      this.searchTokens = [];
      this.searchCompact = '';
      this.remoteSearchHandles.clear();
      this.remoteSearchCategories.clear();
    }

    matchesPhotoSearch(photo) {
      if (!this.searchTerm) return true;

      const tokenMatch = this.searchTokens.length
        ? this.searchTokens.every((token) => photo.searchText.includes(token))
        : true;
      const compactMatch = this.searchCompact.length >= 3 && photo.searchCompact.includes(this.searchCompact);
      const productMatch = photo.products.some((handle) => this.remoteSearchHandles.has(handle));
      const categoryMatch = photo.categories.some((category) => this.remoteSearchCategories.has(category));
      return tokenMatch || compactMatch || productMatch || categoryMatch;
    }

    async lookupMatchingProducts(rawTerm) {
      const term = String(rawTerm || '').trim();
      const token = ++this.searchRequestToken;
      if (this.searchAbortController) this.searchAbortController.abort();
      this.searchAbortController = null;

      if (term.length < 2 || /^sbr[\s-]*\d+$/i.test(term)) return;

      const controller = typeof AbortController === 'function' ? new AbortController() : null;
      this.searchAbortController = controller;

      try {
        const endpoint = new URL(`${this.rootUrl}search/suggest.json`, window.location.origin);
        endpoint.searchParams.set('q', term);
        endpoint.searchParams.set('resources[type]', 'product');
        endpoint.searchParams.set('resources[limit]', '10');
        endpoint.searchParams.set('resources[limit_scope]', 'each');
        endpoint.searchParams.set('resources[options][unavailable_products]', 'last');
        endpoint.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,variants.sku,tag,vendor');

        const response = await fetch(endpoint.toString(), {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          signal: controller?.signal
        });
        if (!response.ok) throw new Error(`Predictive search returned ${response.status}`);
        const payload = await response.json();
        if (token !== this.searchRequestToken) return;

        const products = payload?.resources?.results?.products || [];
        const handles = [];
        const categories = [];
        products.forEach((product) => {
          const handle = normaliseHandle(product.handle || product.url || '');
          if (handle) handles.push(handle);
          const productText = [
            product.title,
            product.type,
            product.product_type,
            product.vendor,
            asArray(product.tags).join(' '),
            product.url,
            handle
          ].filter(Boolean).join(' ');
          categories.push(...inferCategoriesFromText(productText));
        });

        this.remoteSearchHandles = new Set(unique(handles));
        this.remoteSearchCategories = new Set(unique(categories));
        this.applyFilters({ closeDrawer: false });
      } catch (error) {
        if (error?.name === 'AbortError') return;
        // Local photo tags continue to work even if predictive product search is unavailable.
      }
    }

    initAutoLoadMore() {
      if (!this.autoLoadMore || !this.loadArea || typeof IntersectionObserver !== 'function') return;

      if (this.autoLoadObserver) this.autoLoadObserver.disconnect();
      this.autoLoadObserver = new IntersectionObserver((entries) => {
        const entry = entries.find((item) => item.target === this.loadArea);
        if (!entry || !entry.isIntersecting || this.autoLoadPending || this.loadArea.hidden) return;

        this.autoLoadPending = true;
        this.autoLoadObserver.unobserve(this.loadArea);

        window.requestAnimationFrame(() => {
          const loaded = this.loadMore();
          window.setTimeout(() => {
            this.autoLoadPending = false;
            if (loaded && this.autoLoadObserver && this.loadArea && !this.loadArea.hidden) {
              this.autoLoadObserver.observe(this.loadArea);
            }
          }, 260);
        });
      }, {
        root: null,
        rootMargin: '0px 0px 700px 0px',
        threshold: 0.01
      });

      if (!this.loadArea.hidden) this.autoLoadObserver.observe(this.loadArea);
    }

    initStickyControls() {
      if (!this.stickyControls) return;
      window.addEventListener('scroll', this.onViewportChange, { passive: true });
      window.addEventListener('resize', this.onViewportChange, { passive: true });

      if (typeof ResizeObserver === 'function') {
        this.stickyResizeObserver = new ResizeObserver(() => this.scheduleStickyMetrics());
        this.stickyResizeObserver.observe(this.stickyControls);
        const header = document.querySelector('.swan-pro-header-section, .site-header-sticky');
        if (header) this.stickyResizeObserver.observe(header);
      }
      this.scheduleStickyMetrics();
    }

    scheduleStickyMetrics() {
      if (!this.stickyControls || this.stickyFrame) return;
      this.stickyFrame = window.requestAnimationFrame(() => {
        this.stickyFrame = null;
        this.updateStickyMetrics();
      });
    }

    updateStickyMetrics() {
      if (!this.stickyControls) return;
      const stickyHeader = document.querySelector(
        '.site-header--sticky.swan-pro-header, .swan-pro-header-wrapper.header-wrapper--sticky .swan-pro-header'
      );
      let headerOffset = 0;
      if (stickyHeader) {
        const headerRect = stickyHeader.getBoundingClientRect();
        if (headerRect.bottom > 0 && headerRect.top <= 4) headerOffset = Math.max(0, Math.ceil(headerRect.bottom));
      }

      const controlsHeight = Math.max(1, Math.ceil(this.stickyControls.getBoundingClientRect().height));
      this.root.style.setProperty('--sbr-sticky-offset', `${headerOffset}px`);
      this.root.style.setProperty('--sbr-controls-height', `${controlsHeight}px`);

      const controlsRect = this.stickyControls.getBoundingClientRect();
      const sentinelRect = this.stickySentinel?.getBoundingClientRect();
      const sectionRect = this.root.getBoundingClientRect();
      const stickyThreshold = sentinelRect ? sentinelRect.top : controlsRect.top;
      const isStuck = stickyThreshold <= headerOffset + 1
        && sectionRect.top < headerOffset
        && sectionRect.bottom > headerOffset + controlsHeight + 20;
      this.stickyControls.classList.toggle('is-stuck', isStuck);
    }

    renderCategoryFilters() {
      if (!this.categoriesContainer) return;
      const counts = new Map();
      this.photos.forEach((photo) => {
        photo.categories.forEach((category) => counts.set(category, (counts.get(category) || 0) + 1));
      });

      const ordered = unique([
        ...CATEGORY_ORDER.filter((category) => counts.has(category)),
        ...Array.from(counts.keys()).sort((a, b) => a.localeCompare(b))
      ]);

      this.categoriesContainer.innerHTML = ordered.map((category) => `
        <label class="sbr-category-option">
          <input type="checkbox" value="${escapeHTML(category)}" data-sbr-category>
          <span class="sbr-category-check" aria-hidden="true">
            <svg viewBox="0 0 16 16"><path d="m3 8 3 3 7-7"/></svg>
          </span>
          <span class="sbr-category-name">${escapeHTML(category)}</span>
          <span class="sbr-category-count">${counts.get(category) || 0}</span>
        </label>
      `).join('');
    }

    updateRoomCounts() {
      ROOM_ORDER.forEach((room) => {
        const count = room === 'All'
          ? this.photos.length
          : this.photos.filter((photo) => photo.rooms.includes(room)).length;
        this.root.querySelectorAll(`[data-sbr-room-count="${CSS.escape(room)}"]`).forEach((element) => {
          element.textContent = String(count);
        });
      });
    }

    applyFilters(options) {
      const settings = Object.assign({ closeDrawer: true }, options || {});
      let filtered = this.photos.filter((photo) => {
        const roomMatch = this.selectedRoom === 'All' || photo.rooms.includes(this.selectedRoom);
        const categoryMatch = this.selectedCategories.size === 0
          || photo.categories.some((category) => this.selectedCategories.has(category));
        const searchMatch = this.matchesPhotoSearch(photo);
        return roomMatch && categoryMatch && searchMatch;
      });

      if (this.sortMode === 'newest') {
        filtered.sort((a, b) => b.timestamp - a.timestamp || a.originalIndex - b.originalIndex);
      } else if (this.sortMode === 'photo-number') {
        filtered.sort((a, b) => numericPhotoPart(a.photoNumber) - numericPhotoPart(b.photoNumber));
      } else {
        filtered.sort((a, b) => Number(b.featured) - Number(a.featured) || a.originalIndex - b.originalIndex);
      }

      this.filteredPhotos = filtered;
      this.visibleCount = Math.min(this.initialCount, filtered.length);
      this.renderGallery();
      this.renderActiveFilters();
      this.updateFilterTotal();
      if (settings.closeDrawer && window.matchMedia('(max-width: 899px)').matches) this.closeFilters();
    }

    renderGallery() {
      if (!this.gallery) return;
      this.gallery.setAttribute('aria-busy', 'false');
      this.gallery.innerHTML = '';

      if (!this.filteredPhotos.length) {
        if (this.emptyState) this.emptyState.hidden = false;
        if (this.loadArea) this.loadArea.hidden = true;
        this.updateResultText();
        return;
      }

      if (this.emptyState) this.emptyState.hidden = true;
      const fragment = document.createDocumentFragment();
      this.filteredPhotos.slice(0, this.visibleCount).forEach((photo, index) => {
        fragment.appendChild(this.createPhotoCard(photo, index));
      });
      this.gallery.appendChild(fragment);
      this.updateResultText();
      this.updateLoadArea();
    }

    createPhotoCard(photo, visibleIndex) {
      const article = document.createElement('article');
      article.className = 'sbr-card';
      article.dataset.photoId = photo.photoNumber;

      const saved = this.isFavourite(photo.photoNumber);
      const src = responsiveImageUrl(photo.imageUrl, 720);
      const srcset = [360, 560, 720, 960]
        .map((width) => `${responsiveImageUrl(photo.imageUrl, width)} ${width}w`)
        .join(', ');
      const primaryRoom = photo.rooms[0] || 'Inspiration';
      const categoryText = photo.categories.slice(0, 2).join(' · ') || 'Swan Wall Décor';
      const loading = visibleIndex < 2 ? 'eager' : 'lazy';
      const fetchPriority = visibleIndex < 2 ? 'high' : 'auto';

      article.innerHTML = `
        <button type="button" class="sbr-card-open" data-sbr-open-photo data-photo-id="${escapeHTML(photo.photoNumber)}" aria-label="Open ${escapeHTML(photo.photoNumber)}: ${escapeHTML(photo.alt)}">
          <div class="sbr-card-media">
            <img
              class="sbr-card-image is-loading"
              src="${escapeHTML(src)}"
              srcset="${escapeHTML(srcset)}"
              sizes="(max-width: 639px) 48vw, (max-width: 899px) 31vw, (max-width: 1399px) 27vw, 22vw"
              alt="${escapeHTML(photo.alt)}"
              width="${photo.width}"
              height="${photo.height}"
              loading="${loading}"
              fetchpriority="${fetchPriority}"
              decoding="async"
            >
            <span class="sbr-card-number">${escapeHTML(photo.photoNumber)}</span>
            <span class="sbr-card-copy">
              <span class="sbr-card-copy-text">
                <span class="sbr-card-room">${escapeHTML(primaryRoom)}</span>
                <span class="sbr-card-category">${escapeHTML(categoryText)}</span>
              </span>
              <span class="sbr-card-shop-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
              </span>
            </span>
          </div>
        </button>
        <button
          type="button"
          class="sbr-favourite-button${saved ? ' is-saved' : ''}"
          data-sbr-favourite
          data-photo-id="${escapeHTML(photo.photoNumber)}"
          aria-label="${saved ? 'Remove' : 'Save'} ${escapeHTML(photo.photoNumber)} ${saved ? 'from' : 'to'} favourites"
          aria-pressed="${saved ? 'true' : 'false'}"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.7a5.5 5.5 0 0 0-7.8 0L12 5.8l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1.1L12 21l7.8-7.4 1.1-1.1a5.5 5.5 0 0 0-.1-7.8Z"/></svg>
        </button>
      `;

      const image = article.querySelector('.sbr-card-image');
      image.addEventListener('load', () => image.classList.replace('is-loading', 'is-loaded'), { once: true });
      image.addEventListener('error', () => image.classList.remove('is-loading'), { once: true });
      if (image.complete) image.classList.replace('is-loading', 'is-loaded');

      return article;
    }

    loadMore() {
      if (this.isAppendingPhotos || this.visibleCount >= this.filteredPhotos.length) return false;
      this.isAppendingPhotos = true;

      const previousCount = this.visibleCount;
      this.visibleCount = Math.min(this.visibleCount + this.batchCount, this.filteredPhotos.length);
      const fragment = document.createDocumentFragment();
      this.filteredPhotos.slice(previousCount, this.visibleCount).forEach((photo, index) => {
        fragment.appendChild(this.createPhotoCard(photo, previousCount + index));
      });
      this.gallery.appendChild(fragment);
      this.updateResultText();
      this.updateLoadArea();
      this.isAppendingPhotos = false;
      return true;
    }

    updateResultText() {
      const total = this.filteredPhotos.length;
      const showing = Math.min(this.visibleCount, total);
      const roomText = this.selectedRoom === 'All' ? 'all rooms' : this.selectedRoom;
      const text = total
        ? `Showing ${showing} of ${total} photos for ${roomText}`
        : `No photos found for ${roomText}`;
      if (this.results) this.results.textContent = text;
      if (this.mobileResults) this.mobileResults.textContent = total ? `${total} photos` : 'No matches';
    }

    updateLoadArea() {
      if (!this.loadArea) return;
      const hasMore = this.visibleCount < this.filteredPhotos.length;
      this.loadArea.hidden = !hasMore;
      if (this.progress) this.progress.textContent = `You have seen ${Math.min(this.visibleCount, this.filteredPhotos.length)} of ${this.filteredPhotos.length}`;

      if (this.autoLoadObserver) {
        this.autoLoadObserver.unobserve(this.loadArea);
        if (hasMore && !this.autoLoadPending) this.autoLoadObserver.observe(this.loadArea);
      }
    }

    renderActiveFilters() {
      if (!this.activeFilters) return;
      const chips = [];
      if (this.selectedRoom !== 'All') chips.push({ type: 'room', value: this.selectedRoom, label: this.selectedRoom });
      this.selectedCategories.forEach((category) => chips.push({ type: 'category', value: category, label: category }));
      if (this.searchTerm) chips.push({ type: 'search', value: this.searchDisplayTerm, label: `“${this.searchDisplayTerm}”` });

      this.activeFilters.innerHTML = chips.map((chip) => `
        <button type="button" class="sbr-active-filter" data-sbr-remove-filter data-filter-type="${escapeHTML(chip.type)}" data-filter-value="${escapeHTML(chip.value)}">
          <span>${escapeHTML(chip.label)}</span>
          <svg viewBox="0 0 16 16" aria-hidden="true"><path d="m4 4 8 8M12 4l-8 8"/></svg>
        </button>
      `).join('');
    }

    updateFilterTotal() {
      const total = this.selectedCategories.size + (this.selectedRoom === 'All' ? 0 : 1) + (this.searchTerm ? 1 : 0);
      if (this.filterTotal) {
        this.filterTotal.textContent = String(total);
        this.filterTotal.hidden = total === 0;
      }
    }

    resetFilters() {
      this.selectedRoom = 'All';
      this.selectedCategories.clear();
      this.clearSearchState();
      this.sortMode = this.defaultSort;
      if (this.searchInput) this.searchInput.value = '';
      if (this.sortSelect) this.sortSelect.value = this.defaultSort;
      this.categoriesContainer?.querySelectorAll('input[data-sbr-category]').forEach((input) => {
        input.checked = false;
      });
      this.root.querySelectorAll('[data-sbr-room]').forEach((button) => {
        const active = button.dataset.sbrRoom === 'All';
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.applyFilters();
    }

    showDataError() {
      if (this.gallery) this.gallery.innerHTML = '';
      if (this.emptyState) {
        this.emptyState.hidden = false;
        const title = this.emptyState.querySelector('h3');
        const paragraph = this.emptyState.querySelector('p');
        if (title) title.textContent = 'Shop by Room data needs attention';
        if (paragraph) paragraph.textContent = 'Please check Assets → shop-by-room-data.json in the theme code editor.';
      }
      if (this.results) this.results.textContent = 'Gallery unavailable';
      if (this.mobileResults) this.mobileResults.textContent = 'Gallery unavailable';
    }

    getFavouriteKey() {
      return `swanShopByRoomFavorites:${this.customerId}`;
    }

    getFavouriteIds() {
      if (!this.customerId) return [];
      try {
        const stored = JSON.parse(localStorage.getItem(this.getFavouriteKey()) || '[]');
        return Array.isArray(stored) ? unique(stored.map(String)) : [];
      } catch (error) {
        return [];
      }
    }

    isFavourite(photoNumber) {
      return this.customerId ? this.getFavouriteIds().includes(String(photoNumber)) : false;
    }

    toggleFavourite(photoNumber) {
      const id = String(photoNumber || '');
      if (!id) return;
      if (!this.customerId) {
        this.showAuthPrompt(id);
        return;
      }

      const favourites = this.getFavouriteIds();
      const index = favourites.indexOf(id);
      let saved;
      if (index >= 0) {
        favourites.splice(index, 1);
        saved = false;
      } else {
        favourites.unshift(id);
        saved = true;
      }
      localStorage.setItem(this.getFavouriteKey(), JSON.stringify(favourites));
      this.updateFavouriteButtons(id, saved);
      this.showToast(saved ? `${id} saved to Favourite Photos.` : `${id} removed from Favourite Photos.`);
      window.dispatchEvent(new CustomEvent('sbr:favourites-updated', { detail: { customerId: this.customerId } }));
    }

    updateFavouriteButtons(photoNumber, saved) {
      this.root.querySelectorAll(`[data-photo-id="${CSS.escape(photoNumber)}"][data-sbr-favourite]`).forEach((button) => {
        button.classList.toggle('is-saved', saved);
        button.setAttribute('aria-pressed', saved ? 'true' : 'false');
        button.setAttribute('aria-label', `${saved ? 'Remove' : 'Save'} ${photoNumber} ${saved ? 'from' : 'to'} favourites`);
      });

      if (this.currentPhoto?.photoNumber === photoNumber && this.modalFavourite) {
        this.modalFavourite.classList.toggle('is-saved', saved);
        this.modalFavourite.setAttribute('aria-pressed', saved ? 'true' : 'false');
        this.modalFavourite.setAttribute('aria-label', saved ? 'Remove this photo from favourites' : 'Save this photo to favourites');
      }
    }

    showAuthPrompt(photoNumber) {
      if (!this.authDialog) {
        window.location.href = this.loginUrl;
        return;
      }
      const returnUrl = `${window.location.pathname}${window.location.search}${window.location.hash || `#${this.anchor}`}`;
      const separator = this.loginUrl.includes('?') ? '&' : '?';
      if (this.authSignInLink) this.authSignInLink.href = `${this.loginUrl}${separator}return_url=${encodeURIComponent(returnUrl)}`;
      this.authDialog.dataset.pendingPhoto = photoNumber || '';
      this.authDialog.hidden = false;
      document.documentElement.classList.add('sbr-no-scroll');
      this.authDialog.querySelector('.sbr-auth-primary')?.focus();
    }

    hideAuthPrompt() {
      if (!this.authDialog) return;
      this.authDialog.hidden = true;
      if (!this.modal || this.modal.hidden) document.documentElement.classList.remove('sbr-no-scroll');
    }

    openPhoto(photoNumber) {
      const id = String(photoNumber || '');
      const photo = this.photos.find((item) => item.photoNumber === id);
      if (!photo || !this.modal) return;

      this.currentModalList = this.filteredPhotos.some((item) => item.photoNumber === id)
        ? this.filteredPhotos
        : this.photos;
      this.currentModalIndex = this.currentModalList.findIndex((item) => item.photoNumber === id);
      this.currentPhoto = photo;
      this.lastFocusedElement = document.activeElement;
      this.modal.hidden = false;
      document.documentElement.classList.add('sbr-no-scroll');
      document.addEventListener('keydown', this.onKeyDown);
      this.updateModalPhoto();
      window.requestAnimationFrame(() => this.dialog?.focus());
    }

    updateModalPhoto() {
      const photo = this.currentModalList[this.currentModalIndex];
      if (!photo) return;
      this.currentPhoto = photo;

      if (this.modalNumber) this.modalNumber.textContent = photo.photoNumber;
      if (this.modalTitle) this.modalTitle.textContent = photo.title;
      if (this.modalCaption) this.modalCaption.textContent = photo.alt;
      if (this.modalTags) {
        this.modalTags.innerHTML = [...photo.rooms, ...photo.categories]
          .map((tag) => `<span class="sbr-modal-tag">${escapeHTML(tag)}</span>`)
          .join('');
      }

      const saved = this.isFavourite(photo.photoNumber);
      if (this.modalFavourite) {
        this.modalFavourite.classList.toggle('is-saved', saved);
        this.modalFavourite.setAttribute('aria-pressed', saved ? 'true' : 'false');
        this.modalFavourite.setAttribute('aria-label', saved ? 'Remove this photo from favourites' : 'Save this photo to favourites');
      }

      if (this.modalImage) {
        this.modalImage.classList.remove('is-loaded');
        this.modalImage.alt = photo.alt;
        this.modalImage.width = photo.width;
        this.modalImage.height = photo.height;
        if (this.imageLoader) this.imageLoader.hidden = false;
        this.modalImage.src = responsiveImageUrl(photo.imageUrl, 1900);
      }

      const previous = this.root.querySelector('[data-sbr-prev]');
      const next = this.root.querySelector('[data-sbr-next]');
      const disableNav = this.currentModalList.length < 2;
      if (previous) previous.disabled = disableNav;
      if (next) next.disabled = disableNav;

      this.loadProductsForPhoto(photo);
    }

    closeModal() {
      if (!this.modal || this.modal.hidden) return;
      this.modal.hidden = true;
      this.productRequestToken += 1;
      document.removeEventListener('keydown', this.onKeyDown);
      if (!this.authDialog || this.authDialog.hidden) document.documentElement.classList.remove('sbr-no-scroll');
      if (this.modalImage) {
        this.modalImage.removeAttribute('src');
        this.modalImage.classList.remove('is-loaded');
      }
      this.currentPhoto = null;
      this.currentProducts = [];
      if (this.lastFocusedElement && typeof this.lastFocusedElement.focus === 'function') this.lastFocusedElement.focus();
    }

    navigateModal(direction) {
      if (this.currentModalList.length < 2) return;
      this.currentModalIndex = (this.currentModalIndex + direction + this.currentModalList.length) % this.currentModalList.length;
      this.updateModalPhoto();
    }

    onKeyDown(event) {
      if (!this.modal || this.modal.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        this.closeModal();
        return;
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.navigateModal(-1);
        return;
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.navigateModal(1);
        return;
      }
      if (event.key === 'Tab' && this.dialog) {
        const focusable = getFocusableElements(this.dialog);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }

    getShareUrl(photo) {
      const url = new URL(window.location.href);
      url.searchParams.set('room-photo', photo.photoNumber);
      url.hash = this.anchor;
      return url.toString();
    }

    async shareCurrentPhoto() {
      if (!this.currentPhoto) return;
      const shareUrl = this.getShareUrl(this.currentPhoto);
      const shareData = {
        title: `${this.currentPhoto.photoNumber} | Swan Canada Shop by Room`,
        text: `See this ${this.currentPhoto.rooms[0] || 'room'} wall design from Swan Canada.`,
        url: shareUrl
      };

      try {
        if (navigator.share) {
          await navigator.share(shareData);
          return;
        }
        await navigator.clipboard.writeText(shareUrl);
        this.showToast('Photo link copied.');
      } catch (error) {
        if (error?.name === 'AbortError') return;
        try {
          const temporary = document.createElement('textarea');
          temporary.value = shareUrl;
          temporary.style.position = 'fixed';
          temporary.style.opacity = '0';
          document.body.appendChild(temporary);
          temporary.select();
          document.execCommand('copy');
          temporary.remove();
          this.showToast('Photo link copied.');
        } catch (fallbackError) {
          this.showToast('Copy this page address to share the photo.');
        }
      }
    }

    async loadProductsForPhoto(photo) {
      const token = ++this.productRequestToken;
      this.currentProducts = [];
      if (this.productsContainer) this.productsContainer.innerHTML = '';
      if (this.addAllButton) this.addAllButton.hidden = true;
      if (this.productsStatus) {
        this.productsStatus.hidden = false;
        this.productsStatus.innerHTML = '<span class="sbr-products-spinner" aria-hidden="true"></span><span>Finding products for this design…</span>';
      }

      try {
        let products = [];
        if (photo.products.length) {
          const responses = await Promise.allSettled(photo.products.slice(0, this.maxProducts).map((handle) => this.fetchProduct(handle)));
          products = responses.filter((result) => result.status === 'fulfilled' && result.value).map((result) => result.value);
        } else {
          products = await this.fetchCategoryProducts(photo.categories);
        }

        if (token !== this.productRequestToken) return;
        this.currentProducts = unique(products.map((product) => product.handle))
          .map((handle) => products.find((product) => product.handle === handle))
          .filter(Boolean)
          .slice(0, this.maxProducts);
        this.enrichPhotoSearch(photo, this.currentProducts);
        this.renderProducts(photo);
      } catch (error) {
        if (token !== this.productRequestToken) return;
        console.warn('[Swan Shop by Room] Product lookup failed', error);
        this.currentProducts = [];
        this.renderProducts(photo);
      }
    }

    async fetchProduct(handle) {
      const cleanHandle = normaliseHandle(handle);
      if (!cleanHandle) return null;
      if (this.productCache.has(cleanHandle)) return this.productCache.get(cleanHandle);

      const request = fetch(`${this.rootUrl}products/${encodeURIComponent(cleanHandle)}.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then((response) => {
          if (!response.ok) throw new Error(`Product ${cleanHandle} returned ${response.status}`);
          return response.json();
        })
        .then((product) => this.normaliseProduct(product));

      this.productCache.set(cleanHandle, request);
      return request;
    }

    async fetchCategoryProducts(categories) {
      const collectionHandles = unique(categories.map((category) => CATEGORY_COLLECTIONS[category]).filter(Boolean));
      if (!collectionHandles.length) return [];

      const requests = collectionHandles.map((handle) => this.fetchCollection(handle));
      const results = await Promise.allSettled(requests);
      const merged = [];
      results.forEach((result) => {
        if (result.status === 'fulfilled') merged.push(...result.value);
      });
      merged.sort((a, b) => Number(b.available) - Number(a.available));
      return merged.slice(0, this.maxProducts);
    }

    async fetchCollection(handle) {
      if (this.collectionCache.has(handle)) return this.collectionCache.get(handle);
      const request = fetch(`${this.rootUrl}collections/${encodeURIComponent(handle)}/products.json?limit=${Math.max(4, this.maxProducts)}`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then((response) => {
          if (!response.ok) throw new Error(`Collection ${handle} returned ${response.status}`);
          return response.json();
        })
        .then((payload) => (payload.products || []).map((product) => this.normaliseProduct(product)).filter(Boolean));
      this.collectionCache.set(handle, request);
      return request;
    }

    enrichPhotoSearch(photo, products) {
      if (!photo?.products?.length || !products?.length) return;
      const extraTerms = [];
      products.forEach((product) => {
        extraTerms.push(product.title, product.handle);
        product.variants.forEach((variant) => extraTerms.push(variant.title, variant.sku));
      });
      const extraText = normaliseSearchValue(extraTerms.filter(Boolean).join(' '));
      const extraCompact = compactSearchValue(extraTerms.filter(Boolean).join(' '));
      if (extraText && !photo.searchText.includes(extraText)) photo.searchText = `${photo.searchText} ${extraText}`.trim();
      if (extraCompact && !photo.searchCompact.includes(extraCompact)) photo.searchCompact = `${photo.searchCompact}${extraCompact}`;
    }

    normaliseProduct(product) {
      if (!product || !product.handle) return null;
      const variants = (product.variants || []).map((variant) => ({
        id: String(variant.id),
        title: String(variant.public_title || variant.title || '').replace(/^Default Title$/i, ''),
        available: variant.available !== false,
        price: parsePriceToCents(variant.price),
        sku: String(variant.sku || '')
      }));
      const available = variants.some((variant) => variant.available);
      const firstVariant = variants.find((variant) => variant.available) || variants[0] || null;
      const imageObject = Array.isArray(product.images) && product.images.length ? product.images[0] : null;
      const featuredImage = product.featured_image || product.featuredImage || product.image || imageObject || '';
      const image = toAbsoluteUrl(
        typeof featuredImage === 'string' ? featuredImage : (featuredImage.src || featuredImage.url || '')
      );

      return {
        handle: product.handle,
        title: String(product.title || product.handle),
        image,
        url: `${this.rootUrl}products/${product.handle}`,
        variants,
        available,
        firstVariant
      };
    }

    renderProducts(photo) {
      if (this.productsStatus) this.productsStatus.hidden = true;
      if (!this.productsContainer) return;

      if (!this.currentProducts.length) {
        const collections = unique(photo.categories.map((category) => ({
          category,
          handle: CATEGORY_COLLECTIONS[category]
        })).filter((entry) => entry.handle));

        if (collections.length) {
          this.productsContainer.innerHTML = collections.slice(0, this.maxProducts).map((entry) => `
            <a class="sbr-collection-card" href="${escapeHTML(`${this.rootUrl}collections/${entry.handle}`)}">
              <span><strong>Explore ${escapeHTML(entry.category)}</strong><span>Browse products related to this design</span></span>
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
            </a>
          `).join('');
        } else {
          this.productsContainer.innerHTML = `
            <div class="sbr-products-status">
              <span>Products have not been assigned to this photo yet. Use the design-help link below and quote ${escapeHTML(photo.photoNumber)}.</span>
            </div>
          `;
        }
        if (this.addAllButton) this.addAllButton.hidden = true;
        return;
      }

      this.productsContainer.innerHTML = this.currentProducts.map((product, productIndex) => {
        const availableVariants = product.variants.filter((variant) => variant.available);
        const selected = availableVariants[0] || product.variants[0] || null;
        const soldOut = !selected || !selected.available;
        const variantSelect = availableVariants.length > 1 ? `
          <select class="sbr-product-variant" data-sbr-variant-select data-product-index="${productIndex}" aria-label="Choose ${escapeHTML(product.title)} option">
            ${availableVariants.map((variant) => `<option value="${escapeHTML(variant.id)}" data-price="${variant.price}">${escapeHTML(variant.title || 'Default')}</option>`).join('')}
          </select>
        ` : '';
        const image = product.image ? responsiveImageUrl(product.image, 220) : '';

        return `
          <article class="sbr-product-card" data-product-index="${productIndex}">
            <a class="sbr-product-image-link" href="${escapeHTML(product.url)}">
              ${image ? `<img src="${escapeHTML(image)}" alt="${escapeHTML(product.title)}" width="220" height="220" loading="lazy">` : ''}
            </a>
            <div class="sbr-product-info">
              <a class="sbr-product-title" href="${escapeHTML(product.url)}">${escapeHTML(product.title)}</a>
              <span class="sbr-product-price" data-sbr-product-price>${this.formatMoney(selected?.price || 0)}</span>
              ${variantSelect}
              <div class="sbr-product-actions">
                <button
                  type="button"
                  class="sbr-product-add"
                  data-sbr-add-product
                  data-product-index="${productIndex}"
                  data-variant-id="${escapeHTML(selected?.id || '')}"
                  ${soldOut ? 'disabled' : ''}
                >${soldOut ? 'Sold out' : 'Add to cart'}</button>
                <a class="sbr-product-view" href="${escapeHTML(product.url)}" aria-label="View ${escapeHTML(product.title)}">
                  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
                </a>
              </div>
            </div>
          </article>
        `;
      }).join('');

      if (this.addAllButton) this.addAllButton.hidden = !this.currentProducts.some((product) => product.available);
    }

    updateProductVariant(select) {
      const productIndex = Number.parseInt(select.dataset.productIndex || '-1', 10);
      const product = this.currentProducts[productIndex];
      if (!product) return;
      const variant = product.variants.find((item) => item.id === select.value);
      const card = select.closest('.sbr-product-card');
      const addButton = card?.querySelector('[data-sbr-add-product]');
      const price = card?.querySelector('[data-sbr-product-price]');
      if (addButton && variant) addButton.dataset.variantId = variant.id;
      if (price && variant) price.textContent = this.formatMoney(variant.price);
    }

    async addSingleProduct(button) {
      const variantId = button.dataset.variantId;
      if (!variantId || !this.currentPhoto) return;
      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding…';

      try {
        await this.addItemsToCart([{ id: variantId, quantity: 1 }]);
        button.textContent = 'Added';
        this.showToast(`Added to cart from ${this.currentPhoto.photoNumber}.`);
        setTimeout(() => {
          button.disabled = false;
          button.textContent = originalText;
        }, 1500);
      } catch (error) {
        console.warn('[Swan Shop by Room] Add to cart failed', error);
        button.disabled = false;
        button.textContent = originalText;
        this.showToast(error.message || 'This item could not be added to cart.');
      }
    }

    async addAllProducts() {
      if (!this.currentPhoto || !this.productsContainer || !this.addAllButton) return;
      const items = Array.from(this.productsContainer.querySelectorAll('[data-sbr-add-product]:not([disabled])'))
        .map((button) => button.dataset.variantId)
        .filter(Boolean)
        .map((id) => ({ id, quantity: 1 }));
      if (!items.length) return;

      const label = this.addAllButton.querySelector('span');
      const originalText = label?.textContent || 'Add available products';
      this.addAllButton.disabled = true;
      if (label) label.textContent = 'Adding products…';

      try {
        await this.addItemsToCart(items);
        if (label) label.textContent = 'Products added';
        this.showToast(`${items.length} product${items.length === 1 ? '' : 's'} added from ${this.currentPhoto.photoNumber}.`);
        setTimeout(() => {
          this.addAllButton.disabled = false;
          if (label) label.textContent = originalText;
        }, 1700);
      } catch (error) {
        this.addAllButton.disabled = false;
        if (label) label.textContent = originalText;
        this.showToast(error.message || 'The products could not be added to cart.');
      }
    }

    async addItemsToCart(items) {
      const properties = this.currentPhoto ? { '_Shop by Room Photo': this.currentPhoto.photoNumber } : {};
      const response = await fetch(`${this.rootUrl}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: items.map((item) => ({ id: item.id, quantity: item.quantity || 1, properties }))
        })
      });
      const payload = await response.json();
      if (!response.ok) throw new Error(payload.description || payload.message || 'Unable to add this product.');

      document.body.classList.add('cart-has-items');
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: payload } }));
      this.refreshCartCount();
      return payload;
    }

    async refreshCartCount() {
      try {
        const response = await fetch(`${this.rootUrl}cart.js`, { credentials: 'same-origin' });
        const cart = await response.json();
        document.querySelectorAll('.swan-pro-cart-count, .cart-link__bubble-num, [data-cart-count]').forEach((element) => {
          element.textContent = String(cart.item_count);
          element.classList.toggle('is-empty', cart.item_count === 0);
        });
      } catch (error) {
        // The theme's ajaxProduct:added event still rebuilds the cart drawer.
      }
    }

    formatMoney(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
          style: 'currency',
          currency: this.currency,
          minimumFractionDigits: 2
        }).format((Number(cents) || 0) / 100);
      } catch (error) {
        return `$${((Number(cents) || 0) / 100).toFixed(2)}`;
      }
    }

    openFilters() {
      if (!this.filterPanel) return;
      this.filterPanel.classList.add('is-open');
      if (this.filterBackdrop) this.filterBackdrop.hidden = false;
      this.mobileFilterButton?.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('sbr-no-scroll');
      this.filterPanel.querySelector('input, button, select')?.focus();
    }

    closeFilters() {
      if (!this.filterPanel) return;
      this.filterPanel.classList.remove('is-open');
      if (this.filterBackdrop) this.filterBackdrop.hidden = true;
      this.mobileFilterButton?.setAttribute('aria-expanded', 'false');
      if ((this.modal?.hidden !== false) && (this.authDialog?.hidden !== false)) document.documentElement.classList.remove('sbr-no-scroll');
    }

    applyDeepLinkedFilters() {
      const params = new URLSearchParams(window.location.search);
      const requestedRoom = String(params.get('room') || '').trim();
      const requestedSearch = String(params.get('search') || '').trim();

      if (requestedRoom) {
        const requestedKey = compactSearchValue(requestedRoom);
        const matchedRoom = ROOM_ORDER.find((room) => compactSearchValue(room) === requestedKey);

        if (matchedRoom) {
          this.selectedRoom = matchedRoom;
          this.root.querySelectorAll('[data-sbr-room]').forEach((button) => {
            const active = button.dataset.sbrRoom === matchedRoom;
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-selected', active ? 'true' : 'false');
          });
        }
      }

      if (requestedSearch && this.searchInput) {
        this.searchInput.value = requestedSearch;
        this.searchDisplayTerm = requestedSearch;
        this.searchTerm = normaliseSearchValue(requestedSearch);
        this.searchTokens = this.searchTerm ? this.searchTerm.split(' ').filter(Boolean) : [];
        this.searchCompact = compactSearchValue(requestedSearch);
      }
    }

    openDeepLinkedPhoto() {
      const requested = new URLSearchParams(window.location.search).get('room-photo');
      if (!requested) return;
      const photo = this.photos.find((item) => item.photoNumber.toLowerCase() === requested.toLowerCase());
      if (!photo) return;
      this.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setTimeout(() => this.openPhoto(photo.photoNumber), 260);
    }

    showToast(message) {
      if (!this.toast) return;
      clearTimeout(this.toastTimer);
      this.toast.textContent = message;
      this.toast.hidden = false;
      this.toastTimer = setTimeout(() => {
        this.toast.hidden = true;
      }, 3200);
    }
  }

  class SwanAccountFavourites {
    constructor(root) {
      this.root = root;
      this.dataUrl = root.dataset.dataUrl;
      this.customerId = root.dataset.customerId || '';
      this.rootUrl = ensureRoot(root.dataset.rootUrl);
      this.grid = root.querySelector('[data-sbr-account-grid]');
      this.empty = root.querySelector('[data-sbr-account-empty]');
      this.photos = [];
    }

    async init() {
      if (this.root.dataset.sbrAccountInitialized === 'true') return;
      this.root.dataset.sbrAccountInitialized = 'true';
      this.bindTabs();
      this.bindRemove();
      window.addEventListener('sbr:favourites-updated', () => this.render());

      try {
        const response = await fetch(this.dataUrl, { credentials: 'same-origin' });
        const payload = await response.json();
        this.photos = Array.isArray(payload) ? payload : [];
        this.render();
      } catch (error) {
        console.warn('[Swan Favourite Photos]', error);
        this.render();
      }
    }

    getFavouriteKey() {
      return `swanShopByRoomFavorites:${this.customerId}`;
    }

    getFavouriteIds() {
      try {
        const stored = JSON.parse(localStorage.getItem(this.getFavouriteKey()) || '[]');
        return Array.isArray(stored) ? unique(stored.map(String)) : [];
      } catch (error) {
        return [];
      }
    }

    bindTabs() {
      const buttons = Array.from(document.querySelectorAll('[data-sbr-account-tab]'));
      const panels = Array.from(document.querySelectorAll('[data-sbr-account-panel]'));
      const activate = (name, updateHash) => {
        buttons.forEach((button) => {
          const active = button.dataset.sbrAccountTab === name;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach((panel) => {
          panel.hidden = panel.dataset.sbrAccountPanel !== name;
        });
        if (updateHash) {
          const hash = name === 'orders' ? '' : `#${name === 'favourites' ? 'favourite-photos' : name}`;
          history.replaceState({}, '', `${window.location.pathname}${window.location.search}${hash}`);
        }
      };

      buttons.forEach((button) => button.addEventListener('click', () => activate(button.dataset.sbrAccountTab, true)));
      const initial = window.location.hash === '#favourite-photos'
        ? 'favourites'
        : window.location.hash === '#profile'
          ? 'profile'
          : 'orders';
      activate(initial, false);
    }

    bindRemove() {
      this.grid?.addEventListener('click', (event) => {
        const button = event.target.closest('[data-sbr-account-remove]');
        if (!button) return;
        event.preventDefault();
        const id = button.dataset.photoId;
        const favourites = this.getFavouriteIds().filter((item) => item !== id);
        localStorage.setItem(this.getFavouriteKey(), JSON.stringify(favourites));
        this.render();
      });
    }

    render() {
      if (!this.grid) return;
      const ids = this.getFavouriteIds();
      const byId = new Map(this.photos.map((photo) => [String(photo.photo_number || photo.photoNumber), photo]));
      const favourites = ids.map((id) => byId.get(id)).filter(Boolean);
      this.grid.innerHTML = '';

      if (!favourites.length) {
        if (this.empty) this.empty.hidden = false;
        return;
      }
      if (this.empty) this.empty.hidden = true;

      this.grid.innerHTML = favourites.map((photo) => {
        const id = String(photo.photo_number || photo.photoNumber);
        const rooms = asArray(photo.rooms);
        const categories = asArray(photo.categories);
        const image = responsiveImageUrl(photo.image_url || photo.imageUrl, 600);
        const link = createRootURL(this.rootUrl);
        link.searchParams.set('room-photo', id);
        link.hash = 'shop-by-room';
        return `
          <article class="sbr-account-favourite">
            <a class="sbr-account-favourite-link" href="${escapeHTML(link.toString())}">
              <img class="sbr-account-favourite-image" src="${escapeHTML(image)}" alt="${escapeHTML(photo.alt || id)}" width="600" height="450" loading="lazy">
              <span class="sbr-account-favourite-copy">
                <strong>${escapeHTML(id)} · ${escapeHTML(rooms[0] || 'Inspiration')}</strong>
                <span>${escapeHTML(categories.slice(0, 2).join(' · ') || 'Swan Wall Décor')}</span>
              </span>
            </a>
            <button type="button" class="sbr-account-favourite-remove" data-sbr-account-remove data-photo-id="${escapeHTML(id)}" aria-label="Remove ${escapeHTML(id)} from favourite photos">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.7a5.5 5.5 0 0 0-7.8 0L12 5.8l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1.1L12 21l7.8-7.4 1.1-1.1a5.5 5.5 0 0 0-.1-7.8Z"/></svg>
            </button>
          </article>
        `;
      }).join('');
    }
  }

  function initAll(scope) {
    const context = scope || document;
    context.querySelectorAll(selectors.section).forEach((root) => new SwanShopByRoom(root).init());
    context.querySelectorAll(selectors.account).forEach((root) => new SwanAccountFavourites(root).init());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
